import { mutatorAction } from 'satcheljs';
import { getDiagnosticsLogState } from '../store/store';

export default mutatorAction('setSelectedPivot', function setSelectedPivot(pivotKey: string) {
    getDiagnosticsLogState().selectedPivotKey = pivotKey;
});
